import { getTimelineMetaForCategory } from "../../constants/logTypeRegistry";
import { formatTimeForSummary, toEntryDate } from "./panelDashboardTimelineUtils";

const applyPanelDashboardQuickEntryCreate = ({
  entry,
  selectedChild,
  setAllEntries,
  setRecentEntries,
  setTimelineSummary,
}) => {
  if (!selectedChild || (!entry?.text && !Array.isArray(entry?.structuredEntries))) {
    return;
  }

  const entryPayloads = Array.isArray(entry.structuredEntries) && entry.structuredEntries.length > 0
    ? entry.structuredEntries
    : [entry];

  const optimisticEntries = entryPayloads.map((payload, index) => {
    const meta = getTimelineMetaForCategory(payload.category || entry.category, { importantMoment: !!(payload.importantMoment || entry.importantMoment) });
    return {
      id: payload.id || `local-${Date.now()}-${index}`,
      childId: selectedChild.id,
      type: meta.type,
      timelineType: meta.type,
      category: payload.category || entry.category || 'log',
      title: payload.title || payload.titlePrefix || meta.label,
      content: payload.text || entry.text,
      text: payload.text || entry.text,
      notes: payload.notes || payload.bathroomDetails?.notes || null,
      timestamp: payload.timestamp || payload.timestampUtc || entry.timestamp || new Date(),
      localTime: payload.localTime || payload.time || null,
      time: payload.time || payload.localTime || null,
      timeSource: payload.timeSource || null,
      timestampSource: payload.timestampSource || null,
      parserMode: payload.parserMode || null,
      sourceMode: payload.sourceMode || null,
      metadata: payload.metadata || null,
      icon: meta.icon,
      color: meta.color,
      collection: 'dailyLogs',
      tags: payload.tags || entry.tags || [],
      importantMoment: payload.importantMoment || entry.importantMoment || false,
    };
  });

  setRecentEntries((prev) => {
    const nextEntries = [...optimisticEntries, ...(prev[selectedChild.id] || [])]
      .sort((a, b) => toEntryDate(b.timestamp) - toEntryDate(a.timestamp))
      .slice(0, 5);

    return {
      ...prev,
      [selectedChild.id]: nextEntries,
    };
  });

  setAllEntries((current) => {
    const currentEntries = current[selectedChild.id] || [];
    const nextEntries = [...optimisticEntries, ...currentEntries.filter((item) => !optimisticEntries.some((optimistic) => optimistic.id === item.id))]
      .sort((a, b) => toEntryDate(b.timestamp) - toEntryDate(a.timestamp));

    return {
      ...current,
      [selectedChild.id]: nextEntries,
    };
  });

  setTimelineSummary((prev) => {
    const currentSummary = prev[selectedChild.id] || {};
    const nextCount = (currentSummary.todayCount || 0) + optimisticEntries.length;
    const nextWeekCount = (currentSummary.weekCount || 0) + optimisticEntries.length;
    const nextLastActivityTime = formatTimeForSummary(optimisticEntries[0]);

    return {
      ...prev,
      [selectedChild.id]: {
        totalEntries: nextCount,
        todayCount: nextCount,
        weekCount: nextWeekCount,
        activityStreak: currentSummary.activityStreak || 1,
        lastActivityTime: nextLastActivityTime,
      },
    };
  });
};

export { applyPanelDashboardQuickEntryCreate };
